import { useTranslation } from "next-i18next";

import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";

import Styled from "./index.styles";

export default function LandingSectionNumbers() {
  const { t } = useTranslation(["page-company"]);

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  const NUMBERS_SECTION_DATA_LIST = [
    {
      title: t("page-company:숫자섹션_물동량"),
      titleGuide: t("page-company:숫자섹션_물동량_단위"),
      numbers: "234K",
      desc: t("page-company:숫자섹션_물동량_설명"),
    },
    {
      title: t("page-company:숫자섹션_고객사"),
      numbers: "1.3K",
      desc: t("page-company:숫자섹션_고객사_설명"),
    },
    {
      title: t("page-company:숫자섹션_운송구간"),
      numbers: "71",
      desc: t("page-company:숫자섹션_운송구간_설명"),
    },
  ];

  return (
    <Styled.containerWrapper ref={target}>
      <Styled.container>
        <Styled.numbersList>
          {NUMBERS_SECTION_DATA_LIST.map(
            ({ title, titleGuide, numbers, desc }, i) => (
              <Styled.numbersItem
                key={`numbers-${i}`}
                delay={`0.${i}s`}
                className={`fade-up-animation ${
                  isActivatedTarget ? "active" : ""
                }`}
              >
                <span className="title">
                  {title}

                  {titleGuide && <em>({titleGuide})</em>}
                </span>

                <span className="numbers">{numbers}+</span>

                <p className="desc">{desc}</p>
              </Styled.numbersItem>
            )
          )}
        </Styled.numbersList>

        <span
          className={`update-at fade-up-animation ${
            isActivatedTarget ? "active" : ""
          }`}
        >
          ({t("page-company:숫자섹션_기준일자")})
        </span>
      </Styled.container>
    </Styled.containerWrapper>
  );
}
